"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = updateSpacingValue;

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _calculateOptimalSpacingTimeInMins = require("./calculateOptimalSpacingTimeInMins");

var _calculateOptimalSpacingTimeInMins2 = _interopRequireDefault(_calculateOptimalSpacingTimeInMins);

var _utils = require("./utils");

var _consts = require("./consts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function updateSpacingValue(currentSpacing, prevTimeStudied, currentTimeStudied, logError) {
  if (currentSpacing === null || currentSpacing === undefined) {
    return 1;
  }

  if (currentSpacing < 1) {
    logInvalidCurrentSpacing(logError, {
      currentSpacing: currentSpacing,
      prevTimeStudied: prevTimeStudied,
      currentTimeStudied: currentTimeStudied
    });
    return 1;
  }

  var optimalTimeDiff = (0, _calculateOptimalSpacingTimeInMins2.default)(currentSpacing);
  var actualTimeDiff = (0, _moment2.default)(currentTimeStudied).diff((0, _moment2.default)(prevTimeStudied), "minutes");

  var effectiveness = void 0;

  if (actualTimeDiff < 0) {
    logInvalidActualTimeDiff(logError, {
      currentSpacing: currentSpacing,
      prevTimeStudied: prevTimeStudied,
      currentTimeStudied: currentTimeStudied,
      optimalTimeDiff: optimalTimeDiff,
      actualTimeDiff: actualTimeDiff
    });
    effectiveness = 0;
  } else if (actualTimeDiff <= optimalTimeDiff) {
    effectiveness = actualTimeDiff / optimalTimeDiff;
  } else {
    effectiveness = Math.max(0, -actualTimeDiff / (14 * optimalTimeDiff) + (1 + 1 / 14));
  }

  return (0, _utils.roundToDecimals)(currentSpacing + effectiveness, _consts.SPACING_DECIMALS);
}

function logInvalidCurrentSpacing(logError, _ref) {
  var currentSpacing = _ref.currentSpacing,
      prevTimeStudied = _ref.prevTimeStudied,
      currentTimeStudied = _ref.currentTimeStudied;

  logError && logError("updateSpacingValue recieved invalid currentSpacing value: " + currentSpacing + ". Spacing cannot be less that 1. Fixing this instance by setting next spacing to 1.", (0, _utils.convertToLogObject)({
    currentSpacing: currentSpacing,
    prevTimeStudied: prevTimeStudied,
    currentTimeStudied: currentTimeStudied
  }));
}

function logInvalidActualTimeDiff(logError, _ref2) {
  var currentSpacing = _ref2.currentSpacing,
      prevTimeStudied = _ref2.prevTimeStudied,
      currentTimeStudied = _ref2.currentTimeStudied,
      optimalTimeDiff = _ref2.optimalTimeDiff,
      actualTimeDiff = _ref2.actualTimeDiff;

  logError && logError("updateSpacingValue calculated an invalid actualTimeDiff: " + actualTimeDiff + ". This should be >=0.", (0, _utils.convertToLogObject)({
    currentSpacing: currentSpacing,
    prevTimeStudied: prevTimeStudied,
    currentTimeStudied: currentTimeStudied,
    optimalTimeDiff: optimalTimeDiff,
    actualTimeDiff: actualTimeDiff
  }));
}